import { DiwaAPI } from './client'

/** Mirrors PersonResponse in products/diwa/src/diwa/people/router.py */
export interface Person {
  id: string
  first_name: string | null
  last_name: string | null
  email: string | null
  phone: string | null
  title: string | null
  company_name: string | null
  linkedin_url: string | null
  notes: string | null
  relationship_score: number
  enrichment_status: string
  enrichment_confidence: number | null
}

export interface PeopleListResponse {
  people: Person[]
  total: number
  limit: number
  offset: number
}

export interface ListPeopleParams {
  q?: string
  enrichment_status?: string
  limit?: number
  offset?: number
}

export class PeopleAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  list(params: ListPeopleParams = {}): Promise<PeopleListResponse> {
    const search = new URLSearchParams()
    if (params.q) search.set('q', params.q)
    if (params.enrichment_status) search.set('enrichment_status', params.enrichment_status)
    if (params.limit != null) search.set('limit', String(params.limit))
    if (params.offset != null) search.set('offset', String(params.offset))
    const qs = search.toString()
    return this.api.get<PeopleListResponse>(`/people${qs ? `?${qs}` : ''}`)
  }

  get(id: string): Promise<Person> {
    return this.api.get<Person>(`/people/${id}`)
  }
}

export function fullName(p: Person): string {
  const name = [p.first_name, p.last_name].filter(Boolean).join(' ').trim()
  return name || p.email || 'Unnamed'
}
